import { Fragment, h, Host } from '@stencil/core';
import { productCtas, MAX_CTA_LIMIT, ADDITIONAL_CTA_LINKS, NUMBER_OF_BUTTONS_BEFORE, EQdsButtonSize, EQdsButtonImportance, RangeCTAPosition, send, productSelectorVirtualPageEvent, deepMerge, getQdsIconLibrary } from '@pes-ui/utils';
import { updateProductCtasSelectorSettings, } from '../../UI/product-selector/product-selector-utils';
import { CtaSoftwareDropdownItem } from './cta-software-dropdown-item';
import { SoftwareDownloadArea } from './software-download-area';
import { addRangeClickGAEvent } from '../helper';
export class RangeCTA {
  constructor() {
    this.openProductSelector = (selector, item, position) => (_) => {
      if (this.selectorConfigResponse.config.type === 'sc') {
        const selectorModal = document.createElement('pdp-sc-selector-modal');
        const frame = document.createElement('div');
        frame.id = 'widgetFrame';
        selectorModal.headerLabel = this.selectorConfigResponse.config.scLabel || 'Select your product';
        selectorModal.appendChild(frame);
        selectorModal.open = true;
        selectorModal.addEventListener('didClose', () => {
          document.body.removeChild(selectorModal);
        });
        document.body.appendChild(selectorModal);
      }
      selector.open(this.updatedSelectorConfig(this.selectorConfig));
      addRangeClickGAEvent(item, position);
      send(productSelectorVirtualPageEvent);
    };
    this.openButtonLink = (item, position) => {
      addRangeClickGAEvent(item, position);
      window.open(item.url, item.target || '_self');
    };
    this.productSelectorClickHandler = (item, position) => {
      addRangeClickGAEvent(item, position);
      this.productSelectorClick.emit(true);
    };
    this.renderButton = (size, importance, iconName, position) => (item) => {
      return (h("qds-button", { size: size, importance: importance, class: "cta-element", block: true, onClick: () => this.openButtonLink(item, position), text: item.label, iconName: iconName, iconLibrary: getQdsIconLibrary(iconName), variant: "hero" }));
    };
    this.renderProductSelectorButton = (size, importance, iconName, position) => (item) => {
      return (this.selectorConfig && (h("pes-product-selector", { class: "cta-element", config: this.updatedSelectorConfig(this.selectorConfig), renderFunction: (selector) => (h("qds-button", { size: size, importance: importance, class: "cta-element", block: true, onClick: this.isExternalConsumer
            ? this.productSelectorClickHandler(item, position)
            : this.openProductSelector(selector, item, position), text: this.selectorConfigResponse.label, iconName: iconName, variant: "hero", iconLibrary: getQdsIconLibrary(iconName) })) })));
    };
    this.renderSoftwareDownloadDropdownItem = (numberOfButtonsBefore) => (item) => {
      return (h(CtaSoftwareDropdownItem, { additionLinks: item.data.additionLinks, labels: item.data.labels, numberOfButtonsBefore: numberOfButtonsBefore, ctaItem: item, position: RangeCTAPosition.OPTIONS }));
    };
    this.renderSoftwareDownloadArea = (numberOfButtonsBefore, position) => (item) => {
      return (h(SoftwareDownloadArea, { data: item.data, numberOfButtonsBefore: numberOfButtonsBefore, className: "cta-element", ctaItem: item, position: position }));
    };
    this.getProductSelectorForDropdown = () => {
      return (item) => {
        return (this.selectorConfig && (h("pes-product-selector", { config: this.updatedSelectorConfig(this.selectorConfig), renderFunction: (selector) => (h("se-list-item", null, h("button", { class: "cta-software-dropdown-button", onClick: this.openProductSelector(selector, item, RangeCTAPosition.OPTIONS), slot: "start" }, this.selectorConfigResponse.label))) })));
      };
    };
    this.renderDropdownItem = () => (item) => {
      const { url, target, label, type } = item;
      if (url) {
        return (h("a", { class: "dropdownLink", href: url, target: target, onClick: () => addRangeClickGAEvent(item, RangeCTAPosition.OPTIONS) }, h("se-list-item", { item: label })));
      }
      if (type === ADDITIONAL_CTA_LINKS) {
        return this.renderSoftwareDownloadDropdownItem(NUMBER_OF_BUTTONS_BEFORE)(item);
      }
      return this.getProductSelectorForDropdown()(item);
    };
    this.renderMap = {
      'notify-me': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "bell", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'contact-sales': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "check-writing-board", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'contact-support': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "chat-bubbles-square-ellipsis", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'external-product-selector': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, '', RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'buy-online': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "shopping-cart-arrow", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'request-demo': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "laptop-side", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'software-free-trial': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "screen-graph", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'ask-the-community': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "persons-small-big", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'talk-to-an-expert': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "person-writing-pad", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'sc-product-selector': {
        getEmphasized: this.renderProductSelectorButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderProductSelectorButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderProductSelectorButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "squares-checked", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'addition-links': {
        getEmphasized: this.renderSoftwareDownloadArea(0, RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderSoftwareDownloadArea(1, RangeCTAPosition.STANDARD),
        getSubdued: this.renderSoftwareDownloadArea(2, RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
    };
    this.rangeCtas = [];
    this.moreOptionsLabel = undefined;
    this.getSelectorConfig = undefined;
    this.selectorConfigResponse = null;
    this.isExternalConsumer = undefined;
    this.selectorConfig = undefined;
    this.selectorExtraOptions = undefined;
  }
  componentWillLoad() {
    if (this.selectorConfigResponse) {
      this.configureSelector(this.selectorConfigResponse);
    }
    else if (this.getSelectorConfig) {
      this.getSelectorConfig()
        .then((response) => {
        this.selectorConfigResponse = response;
        this.configureSelector(response);
      })
        .catch(console.error);
    }
  }
  configureSelector(response) {
    this.selectorExtraOptions = updateProductCtasSelectorSettings(response, productCtas.buttons);
    this.selectorConfig = response === null || response === void 0 ? void 0 : response.config;
  }
  updatedSelectorConfig(config) {
    return deepMerge(config, { scOptions: this.selectorExtraOptions });
  }
  render() {
    const [primaryCta, secondaryCta, ...ctas] = this.rangeCtas;
    let dropDownCtas = [];
    let linksCtas = [];
    if (ctas.length > MAX_CTA_LIMIT) {
      dropDownCtas = ctas.splice(MAX_CTA_LIMIT);
    }
    linksCtas = ctas;
    return (h(Host, null, h("div", { class: "cta-buttons-block" }, primaryCta && this.renderMap[primaryCta.type].getEmphasized(primaryCta), secondaryCta && this.renderMap[secondaryCta.type].getStandard(secondaryCta)), (linksCtas === null || linksCtas === void 0 ? void 0 : linksCtas.length) > 0 && (h("div", { class: "cta-links-block" }, linksCtas.map((item) => { var _a, _b; return (_b = (_a = this.renderMap[item.type]) === null || _a === void 0 ? void 0 : _a.getSubdued) === null || _b === void 0 ? void 0 : _b.call(_a, item); }))), (dropDownCtas === null || dropDownCtas === void 0 ? void 0 : dropDownCtas.length) > 0 && (h(Fragment, null, h("div", { class: "cta-section-space" }), h("se-dropdown", { class: "cta-dropdown" }, h("se-button", { class: "drp-btn", slot: "trigger", "icon-color": "primary", option: "outline", size: "medium" }, this.moreOptionsLabel), h("se-list", { option: "dropdown" }, dropDownCtas.map((item) => {
      var _a, _b;
      return ((_b = (_a = this.renderMap[item.type]) === null || _a === void 0 ? void 0 : _a.getDropdownLink) === null || _b === void 0 ? void 0 : _b.call(_a, item));
    })))))));
  }
  static get is() { return "pes-range-cta"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-cta.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-cta.css"]
    };
  }
  static get properties() {
    return {
      "rangeCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRangeCTAs",
          "resolved": "TRangeCTAItem[]",
          "references": {
            "TRangeCTAs": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "[]"
      },
      "moreOptionsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "more-options-label",
        "reflect": false
      },
      "getSelectorConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "() => Promise<TSelectorConfigRequestResponse>",
          "resolved": "() => Promise<TSelectorConfigRequestResponse>",
          "references": {
            "Promise": {
              "location": "global"
            },
            "TSelectorConfigRequestResponse": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "selectorConfigResponse": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TSelectorConfigRequestResponse",
          "resolved": "{ label: string; config: TProductSelectorConfig; labels: TProductCtasLabels; }",
          "references": {
            "TSelectorConfigRequestResponse": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "selectorConfig": {},
      "selectorExtraOptions": {}
    };
  }
  static get events() {
    return [{
        "method": "productSelectorClick",
        "name": "productSelectorClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        }
      }];
  }
}
